import React, { createContext, useContext } from "react";
import { Dialog, DialogType } from "@fluentui/react/lib/Dialog";
import { Card, List, Tooltip } from "antd";

import { ExternalLink, File, FilePlus, FileText } from "react-feather";
import { ContextualMenu } from "@fluentui/react";
import MainStore from "../../store/mainStore";

import MonthlyPerformanceStore from "../../../monthly-performance/store/monthlyperformancestore";
import { useNavigate } from "react-router-dom";
import "../../style/globallink.css";
import ReportStore from "../../../../shared/ReportStore";

import { observer } from "mobx-react-lite";
const mainstore = createContext(MainStore);

const MonthlyPerformanceStoreCtx = createContext(MonthlyPerformanceStore);
const reportStoreCtx = createContext(ReportStore);
const dragOptions = {
  moveMenuItemText: "Move",
  closeMenuItemText: "Close",
  menu: ContextualMenu,
};
const dialogContentProps = {
  type: DialogType.close,
  title: "Technical Reports",
  subText: "Choose any of the most frequently downloaded reports",
};
const menuData = [
  {
    title: "NAOC  OER Report",
    desc: "view,download or export OER Provisional Naoc JV Daily Production Report",
    icon: <FileText size={"32"} color="#3D3F96" />,
    link: "",
    value: 1,
  },
  {
    title: "EBENDO  OER Report",
    desc: "view,download or export OER Provisional Ebendo JV Daily Production Report",
    icon: <FileText size={"32"} color="#E03136" />,
    value: 2,
  },
  {
    title: "QUAIBO  OER Report",
    desc: "view,download or export OER Provisional Quaibo JV Daily Production Report",
    icon: <FileText size={"32"} color="#eb2f96" />,
    value: 3,
  },
  {
    title: "Daily Integrated Performance Report",
    desc: "view,download or export daily Integrated Performance report",
    icon: <File size={"32"} color="#FBA832" />,
    value: 4,
  },
  {
    title: "Weekly Production Performance Dashboard",
    desc: "view,download or export weekly production performance dashboard report",
    icon: <FilePlus size={"32"} color="#13c2c2" />,
    value: 5,
  },
  {
    title: "Field Production Summary Report",
    desc: "view,download or export monthly field production summary Report",
    icon: <FilePlus size={"32"} color="#a0d911" />,
    value: 6,
  },
  {
    title: "Flowstation Production Summary",
    desc: "view,download or  export monthly flowstation rroduction summary report",
    icon: <FilePlus size={"32"} color="#722ed1" />,
    value: 7,
  },
  {
    title: "Commercial Monthly Gross Total ",
    desc: "view,download or  export commercial monthly gross total report,Aggregate Hydrocarbon Average;Sales Gas Details;Gas Distribution Analysis",
    icon: <FilePlus size={"32"} color="#d9d9d9" />,
    value: 8,
  },
];

export const TechnicalReport = observer(() => {
  const mainStore = useContext(mainstore);

  const reportStore = useContext(reportStoreCtx);

  const monthlyPerformanceStore = useContext(MonthlyPerformanceStoreCtx);
  const navigate = useNavigate();
  const modalProps = React.useMemo(
    () => ({
      isBlocking: true,

      dragOptions: dragOptions,
    }),
    []
  );
  return (
    <Dialog
      hidden={!mainStore.showTechnicalGlobalLinkDialog}
      onDismiss={() => {
        mainStore.showTechnicalGlobalLinkDialog = false;
      }}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
      minWidth={"45%"}
    >
      <List
        grid={{ gutter: 20, column: 4 }}
        bordered={false}
        dataSource={menuData}
        itemLayout="horizontal"
        size="small"
        renderItem={(item) => (
          <List.Item>
            <Tooltip title={` ${item.desc} `}>
              <Card
                title={
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {item.icon}
                  </div>
                }
                style={{
                  cursor: "pointer",
                  backgroundColor: "white",
                  textAlign: "center",
                }}
                className="globallinks"
                onClick={async () => {
                  mainStore.showTechnicalGlobalLinkDialog = false;
                  switch (item.value) {
                    case 1:
                      navigate("/productiondata/field-daily-production");
                      mainStore.menuSelectedKey = "3";
                      mainStore.menuOpenKey = "14";
                      reportStore.reportName =
                        "QikReach.Reporting.Naoc.OERReport,QikReach.Reporting";
                      reportStore.headerText =
                        "OER Provisional NAOC JV Daily Production";
                      break;
                    case 2:
                      mainStore.menuSelectedKey = "3";
                      mainStore.menuOpenKey = "14";
                      navigate("/productiondata/field-daily-production");
                      reportStore.reportName =
                        "QikReach.Reporting.Ebendo.EbendoOERReport,QikReach.Reporting";
                      reportStore.headerText =
                        "OER Provisional EBENDO JV Daily Production";
                      break;
                    case 3:
                      mainStore.menuSelectedKey = "3";
                      mainStore.menuOpenKey = "14";
                      navigate("/productiondata/field-daily-production");
                      reportStore.reportName =
                        "QikReach.Reporting.Quaibo.QuaiboOERReport,QikReach.Reporting";
                      reportStore.headerText =
                        "OER Provisional QUAIBO JV Daily Production";
                      break;
                    case 4:
                      mainStore.menuSelectedKey = "3";
                      mainStore.menuOpenKey = "14";
                      navigate("/productiondata/field-daily-production");
                      reportStore.reportName =
                        "QikReach.Reporting.Naoc.OERIntegrated,QikReach.Reporting";
                      reportStore.headerText = "Daily Integrated Performance";
                      break;
                    case 5:
                      mainStore.menuSelectedKey = "3";
                      mainStore.menuOpenKey = "14";
                      navigate("/productiondata/field-daily-production");
                      reportStore.reportName =
                        "QikReach.Reporting.WeeklyPerformance.WeeklyDashboard,QikReach.Reporting";
                      reportStore.headerText =
                        "Weekly  Production Performance Dashboard";
                      break;
                    case 6:
                      monthlyPerformanceStore.showNaocMonthlyProductionDialog = true;
                      mainStore.menuSelectedKey = "4";
                      mainStore.menuOpenKey = "14";
                      navigate("/monthly-performance/string-production");
                      reportStore.reportName =
                        "QikReach.Reporting.Naoc.FieldProductionSummary,QikReach.Reporting";
                      reportStore.headerText = "NAOC Field Production Summary";
                      break;
                    case 7:
                      monthlyPerformanceStore.showNaocMonthlyProductionDialog = true;
                      mainStore.menuSelectedKey = "4";
                      mainStore.menuOpenKey = "14";
                      navigate("/monthly-performance/string-production");
                      reportStore.reportName =
                        "QikReach.Reporting.Naoc.FacilityProductionSummary,QikReach.Reporting";
                      reportStore.headerText =
                        "NAOC Flowstation (facility) Production Summary";
                      break;
                    case 8:
                      mainStore.menuSelectedKey = "3";
                      mainStore.menuOpenKey = "14";
                      navigate("/productiondata/field-daily-production");
                      reportStore.reportName =
                        "QikReach.Reporting.Naoc.MainCommaercialFlash,QikReach.Reporting";
                      reportStore.headerText = "Monthly Gross Totals";
                      break;
                    default:
                      break;
                  }

                  reportStore.showReportDialog = true;
                }}
              >
                <div
                  style={{
                    textAlign: "center",

                    display: "flex",
                    color: "#0078d4",
                  }}
                >
                  {item.title} <ExternalLink size={12} />
                </div>
              </Card>
            </Tooltip>
          </List.Item>
        )}
      />
    </Dialog>
  );
});

